import React from "react";
import { useParams } from "react-router-dom";
import SingleMapeProcesa from "../../components/admin/singleMapaProcesa";

function AdminSingeMapaProcesaPage(props) {
  const params = useParams();

  return (
    <div className="admin-page-child-wrapper">
      {/* key forsira remount pri prelasku na drugu mapu (npr. iz pretrage) —
          komponenta učitava podatke samo pri mount-u */}
      <SingleMapeProcesa key={params.id} />
    </div>
  );
}

export default AdminSingeMapaProcesaPage;
